<template>
  <div class="grid grid-cols-4 gap-4">
    <div>
      <base-label>Start Date</base-label>
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="Select a date"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>

    <div>
      <base-label>End Date</base-label>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="Select a date"
        class="w-full"
        format="MM/dd/yyyy"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
    </div>
    <div>
      <base-button-primary class="mt-5 ml-5" @click="handleExport"
        >Export</base-button-primary
      >
    </div>
  </div>
</template>

<script>
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";

export default {
  name: "Photographer",
  components: {
    BaseButtonPrimary,
  },

  props: {},
  data() {
    return {
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    handleExport() {
      if (!this.startDate || !this.endDate) {
        this.$notify({
          title: "Search",
          message: "Please select a start date and end date",
          type: "warning",
        });
        return;
      }
      let url = process.env.VUE_APP_BASE_URL + "/order/export-comprehensive";
      url += this.startDate ? "?startDate=" + this.startDate : "";
      url += this.endDate ? "&endDate=" + this.endDate : "";
      url = encodeURI(url);
      window.open(url, "_blank");
    },
    handleSearch() {
      // if (!this.photographerId) {
      //   this.$notify({
      //     title: "Search",
      //     message: "Please select a photographer",
      //     type: "warning",
      //   });
      //   return;
      // }
      // this.$notify({
      //   title: "Search",
      //   message: "Fetching data...",
      //   type: "success",
      // });
      // const data = {
      //   startDate: this.startDate,
      //   endDate: this.endDate,
      //   photographerId: this.photographerId,
      // };
      // this.$store.dispatch("order/forPhotographer", data).then((resp) => {
      //   this.orders = Object.values(resp.orders);
      //   if (!this.orders.length) {
      //     this.$notify({
      //       title: "Order",
      //       message: "No orders found",
      //       type: "warning",
      //     });
      //   }
      // });
    },
  },
  computed: {},
  watch: {},
  mounted() {},
};
</script>
